const searchField = document.querySelector('.js-site-nav-search');
const searchForm = document.querySelector('.js-search-form');

searchField.addEventListener('input', function(e) {
    let predictiveSearchResults = document.querySelector('.js-search-results');
    if (e.target.value.length > 2) {
        let searchTerm = e.target.value;
        getSuggestions(searchTerm, predictiveSearchResults);
    } else {
        predictiveSearchResults.innerHTML = '';
    }
});


function getSuggestions(searchTerm, predictiveSearchResults) {
    
    document.querySelector('.js-search-page-loader').classList.add('is-visible');
    predictiveSearchResults.innerHTML = '';
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
          document.querySelector('.js-search-page-loader').classList.remove('is-visible');
          predictiveSearchResults.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
}